module.exports = __webpack_public_path__ + "assets/img/yapikredi@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/yapikredi@2x.png
// module id = 146
// module chunks = 0